import { API_VERSION_V2 } from '~/constants';
import { axiosInstance } from '~/services/fetchServiceV2';

import { useDedupeMutation } from '../common';

/** @category useCheckInOut */
export type TypeCheckInOutParams = {
  /** 클러스터 */
  cluster: string;
  /** 센터 */
  center: string;
  /** 업무 파트 */
  workPart: string;
  /** 대분류 작업공정 */
  workProcessCode: string;
  /** 소분류 작업공정 */
  workProcessDetailName: string;
};

/** @category useCheckInOut */
export type TypeCheckInOutResponse = {
  /** 체크인/아웃 아이디 */
  checkInOutId: number;
  /** 클러스터 */
  cluster: string;
  /** 센터 */
  center: string;
  /** 업무 파트 */
  workPart: string;
  /** 대분류 작업공정 */
  workProcess: string;
  /** 소분류 작업공정 */
  workProcessDetailName: string;
  /** 체크인 시각 */
  checkInTime: string;
  /** 체크아웃 시각 */
  checkOutTime: string | null;
  /** 작업자 계정코드 */
  laborAccountId: string;
};

/**
 * @description 작업자가 작업 공정에 체크인 혹은 체크아웃을 처리하는 api 요청에 사용되는 커스텀 훅
 */
export const useCheckInOut = () => {
  const [requestCheckInOut] = useDedupeMutation<TypeCheckInOutParams, TypeCheckInOutResponse>({
    mutationFn: (params: TypeCheckInOutParams) => {
      const endpoint = '/work-process/check';
      return axiosInstance.post<TypeCheckInOutResponse>(endpoint, params, {
        headers: {
          version: API_VERSION_V2,
        },
      });
    },
  });

  return requestCheckInOut;
};
